<template>
  <div class="grafico">
    <div class="canvas-wrapper">
      <Bar :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'ResumenPorEncargadoBarChart',
  components: { Bar },
  props: {
    resumenEncargados: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    chartData() {
      const encargados = Array.isArray(this.resumenEncargados) ? this.resumenEncargados : []
      return {
        labels: encargados.map(e => e.NombreEncargado),
        datasets: [
          {
            label: 'Recuperación mensual (Lps)',
            data: encargados.map(e => e.TotalMes),
            backgroundColor: '#0b1719',
            hoverBackgroundColor: '#0f766e',
            borderRadius: 8,
            barThickness: encargados.length > 5 ? 26 : 34
          }
        ]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          title: {
            display: false,
            text: 'Recuperación Mensual por Encargado'
          },
          tooltip: {
            callbacks: {
              label: context => `${context.parsed.y.toLocaleString()} Lps`
            }
          }
        },
        scales: {
          y: {
            grid: { color: 'rgba(148, 163, 184, 0.22)' },
            beginAtZero: true,
            ticks: {
              callback: value => `${value.toLocaleString()} lps`
            }
          },
          x: {
            grid: { display: false }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.grafico {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0;
}

.canvas-wrapper {
  min-width: 520px;
  height: 330px;
}
</style>
